import ability from './ability'

export const canNavigate = to => to.matched.some(route => {
  const action = route.meta.action || 'read'
  const { resource } = route.meta

  if (!resource) return true
  if (ability.can(action, resource)) return true

  if (typeof resource === 'string') {
    const isV2 = resource.endsWith('V2')
    const equivalent = isV2 ? resource.slice(0, -2) : `${resource}V2`
    if (ability.can(action, equivalent)) return true
    if (action === 'read') {
      if (ability.can('manage', resource) || ability.can('manage', equivalent)) return true
    }
  }

  return false
})

export const _ = undefined
